'use strict';

module.exports = function (column) {
    if (typeof this.opts.initFilters[column] !== 'undefined') {
        return this.opts.initFilters[column];
    }

    if (typeof this.query[column] !== 'undefined' && this.query[column].start) {
        return {
            start: moment(this.query[column].start, 'YYYY-MM-DD HH:mm:ss'),
            end: moment(this.query[column].end, 'YYYY-MM-DD HH:mm:ss')
        };
    }

    return false;
};


//////////////////
// WEBPACK FOOTER
// ./~/vue-tables-2/compiled/methods/get-initial-date-range.js
// module id = 2174
// module chunks = 2